import axios from './axios';

/**
 * Prepare template with auto-populated variables
 */
export const prepareTemplate = async (templateId, params = {}) => {
  const response = await axios.get(`/contract-builder/template/${templateId}/prepare`, { params });
  return response.data;
};

/**
 * Generate contract from template
 */
export const generateContract = async (data) => {
  const response = await axios.post('/contract-builder/generate', data);
  return response; // Fixed: axios already unwraps response.data
};

/**
 * Preview contract before generation
 */
export const previewContract = async (data) => {
  const response = await axios.post('/contract-builder/preview', data);
  return response.data;
};